import { styled } from '@mui/material/styles'

const Container = styled('div')({
  display: 'flex',
  maxWidth: '355px',
  height: '160px',
})

export default Container
